import { FormControlOptions } from '@miq/catalog';

export const PortfolioSaleFormConfig: { [key: string]: FormControlOptions<any> } = Object.freeze({
  company_contact_role_addresses: {
    name: 'company_contact_role_addresses',
    type: 'array',
    controlsConfig: {
      id: [''],
      _mode: [null],
      _contact_id: [null], // ensure presence
      display_order: [null], // ensure presence
      prev_display_order: [null], // ensure presence
      company_id: [null], // ensure presence
      contact_id: [null], // ensure presence
      location_id: [null], // ensure presence - flat mirror of location.location_id (MIQ-36890)
      children: [],
      location: [],
    },
    children: {
      company_industry_classification: {
        name: 'company_industry_classification',
        type: 'array',
        controlsConfig: {
          id: [null],
          ref_naics_classification_desc: [null],
          primary_naics_code_f: [null],
        },
      },
    },
  },
  salecomps: {
    name: 'salecomps',
    type: 'array',
    controlsConfig: {
      _mode: [null],
    },
    children: {
      portfolio: {
        type: 'group',
        name: 'portfolio',
        controlsConfig: {
          id: [null], // ensure presence
        },
      },
      entity: {
        type: 'group',
        name: 'entity',
        controlsConfig: {
          id: [null], // ensure presence
        },
      },
      property: {
        type: 'group',
        name: 'property',
        controlsConfig: {
          id: [null], // ensure presence
        },
      },
    },
  },
});
